export const sliderData = [
  {
    id: 1,
    sliderContent: "Finance",
    sliderImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746452384/slider-finance_xlraco.webp",
  },
  {
    id: 2,
    sliderContent: "Banking",
    sliderImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746452377/slider-bank_c0vo8v.webp",
  },
  {
    id: 3,
    sliderContent: "Insurance",
    sliderImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746452386/slider-insurance_k48lq7.webp",
  },
  {
    id: 4,
    sliderContent: "Legal",
    sliderImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746452387/slider-legal_cliyg2.webp",
  },
  {
    id: 5,
    sliderContent: "Education",
    sliderImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746452378/slider-edu_ai8zpv.webp",
  },
  {
    id: 6,
    sliderContent: "Health",
    sliderImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746452386/slider-health_ybymtf.webp",
  },
  {
    id: 7,
    sliderContent: "Game",
    sliderImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746452384/slider-game_amj0ly.webp",
  },
  {
    id: 8,
    sliderContent: "Entertainment",
    sliderImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746452382/slider-entertain_slhlm7.webp",
  },
  {
    id: 9,
    sliderContent: "Events",
    sliderImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746452383/slider-events_v1q1fz.webp",
  },
  {
    id: 10,
    sliderContent: "On Demand",
    sliderImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746452378/slider-demand_n3wpie.webp",
  },
  {
    id: 11,
    sliderContent: "Retail",
    sliderImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746452390/slider-retail_ckrvup.webp",
  },
  {
    id: 12,
    sliderContent: "Restaurant",
    sliderImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746452390/slider-restaurant_ktvulb.webp",
  },
  {
    id: 13,
    sliderContent: "Travel",
    sliderImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746452390/slider-travel_nitwz7.webp",
  },
  {
    id: 14,
    sliderContent: "Logistics",
    sliderImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746452387/slider-logistics_tmhux0.webp",
  },
  {
    id: 15,
    sliderContent: "Energy",
    sliderImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746452382/slider-energy_ldpp2y.webp",
  },
  {
    id: 16,
    sliderContent: "Agriculture",
    sliderImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746452377/slider-agri_nlaepd.webp",
  },
  {
    id: 17,
    sliderContent: "Real Estate",
    sliderImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746452389/slider-realestate_fjtszc.webp",
  },
  {
    id: 18,
    sliderContent: "Construction",
    sliderImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746452378/slider-construction_rqbiuw.webp",
  },
];

export const webSliderData = [
  {
    id: 1,
    sliderContent: "WEB3.0",
    sliderImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746452391/slider-webThree_akyjff.webp",
  },
  {
    id: 2,
    sliderContent: "WEB2.0",
    sliderImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746452394/slider-webTwo_wevbtw.webp",
  },
  {
    id: 3,
    sliderContent: "AI & ML",
    sliderImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746452377/slider-ai_lrfqdg.webp",
  },
  {
    id: 4,
    sliderContent: "Construction",
    sliderImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746452378/slider-construction_rqbiuw.webp",
  },
  {
    id: 5,
    sliderContent: "Blockchain",
    sliderImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746452378/slider-block_yrsqlq.webp",
  },
  {
    id: 6,
    sliderContent: "Banking",
    sliderImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746452377/slider-bank_c0vo8v.webp",
  },
  {
    id: 7,
    sliderContent: "Insurance",
    sliderImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746452386/slider-insurance_k48lq7.webp",
  },
  {
    id: 8,
    sliderContent: "Legal",
    sliderImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746452387/slider-legal_cliyg2.webp",
  },
  {
    id: 9,
    sliderContent: "Education",
    sliderImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746452378/slider-edu_ai8zpv.webp",
  },
  {
    id: 10,
    sliderContent: "Health",
    sliderImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746452386/slider-health_ybymtf.webp",
  },
  {
    id: 11,
    sliderContent: "Game",
    sliderImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746452384/slider-game_amj0ly.webp",
  },
  {
    id: 12,
    sliderContent: "Entertainment",
    sliderImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746452382/slider-entertain_slhlm7.webp",
  },
  {
    id: 13,
    sliderContent: "Events",
    sliderImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746452383/slider-events_v1q1fz.webp",
  },
  {
    id: 14,
    sliderContent: "On Demand",
    sliderImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746452378/slider-demand_n3wpie.webp",
  },
  {
    id: 15,
    sliderContent: "Retail",
    sliderImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746452390/slider-retail_ckrvup.webp",
  },
  {
    id: 16,
    sliderContent: "Restaurant",
    sliderImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746452390/slider-restaurant_ktvulb.webp",
  },
  {
    id: 17,
    sliderContent: "Travel",
    sliderImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746452390/slider-travel_nitwz7.webp",
  },
  {
    id: 18,
    sliderContent: "Logistics",
    sliderImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746452387/slider-logistics_tmhux0.webp",
  },
];

export const exploreData = [
  {
    id: 1,  
    serviceName: "service 01",
    cardTitle: "Blockchain Service",
    cardImg:
      "https://res.cloudinary.com/dvym3pvnu/image/upload/v1776779520/landExploreDataImg1_xnxvji.webp",
    cardContent:
      "Build secure and scalable blockchain solutions to transform your business processes. Unlock innovation with decentralized technology and smart contracts.",
    cardBtn: "Explore",
    cardLink: "/contact-us",
    cardSubContents: [
      {
        subHead: "Crypto Exchange",
        subContent:
          "Build a secure and scalable cryptocurrency exchange tailored to your needs.",
        subHeadImg: "cardIcon.png",
        subCardLink: "/cryptocurrency-exchange-development-company",
      },
      {
        subHead: "Trading Bot",
        subContent: "Automate your trades with advanced crypto trading bots.",
        subHeadImg: "trading-bot.webp",
        subCardLink: "/crypto-arbitrage-trading-bot",
      },
      {
        subHead: "Defi",
        subContent:
          "Unlock decentralized finance opportunities for transparent and open finance.",
        subHeadImg: "nft.webp",
        subCardLink: "/defi-development-company",
      },
      {
        subHead: "Crypto Token",
        subContent:
          "Launch custom crypto tokens to power your digital economy.",
        subHeadImg: "crypto-token.webp",
        subCardLink: "/token-development-company",
      },
      {
        subHead: "Prediction Market Development",
        subContent:
          "Full-scale Prediction Market Platform Development like Polymarket Clone Script",
        subHeadImg: "nft.webp",
        // subCardLink: "/nft-marketplace-development-service",
        subCardLink: "/prediction-market-development-company",
      },
      {
        subHead: "Crypto Payment",
        subContent:
          "Enable seamless and secure cryptocurrency payments for your business.",
        subHeadImg: "crypto-payment.webp",
        subCardLink: "/crypto-payment-gateway-development-services",
      },
    ],
  },
  {
    id: 2,
    serviceName: "service 02",
    cardTitle: "AI/ML Solution",
    cardImg:
      "https://res.cloudinary.com/dvym3pvnu/image/upload/v1776779522/landExploreDataImg2_pmvft2.webp",
    cardContent:
      "AI and machine learning to automate tasks and help intelligent decision making. Achieve smarter business outcomes with AI powered solutions.",
    cardBtn: "Explore",
    cardLink: "/contact-us",
    cardSubContents: [
      {
        subHead: "AI Development Company",
        subContent: "Partner with experts in advanced AI development services.",
        subHeadImg: "ai-development.webp",
        subCardLink: "/ai-and-ml-development-company",
      },
      {
        subHead: "Generative AI Development",
        subContent:
          "Create innovative AI solutions that generate new content and ideas.",
        subHeadImg: "generative-ai.webp",
        subCardLink: "/generative-ai-development-company",
      },
      {
        subHead: "AI/ML Development",
        subContent:
          "Utilise AI/ML technologies to maximise business growth and progress.",
        subHeadImg: "ai-ml-develop.webp",
        subCardLink: "/machine-learning-consulting-services",
      },
      {
        subHead: "AI Chatbot Development",
        subContent:
          "Develop AI powered chatbot solutions for efficient customer engagement.",
        subHeadImg: "ai-chat.webp",
        subCardLink: "/ai-chatbot-development-company",
      },
    ],
  },
  {
    id: 3,
    serviceName: "service 03",
    cardTitle: "Software Development",
    cardImg:
      "https://res.cloudinary.com/dvym3pvnu/image/upload/v1776779525/landExploreDataImg3_yfooq9.webp",
    cardContent:
      "Develop custom software tailored to your unique needs with advanced technology. Streamline operations and enhance performance with agile development services.",
    cardBtn: "Explore",
    cardLink: "/contact-us",
    cardSubContents: [
      {
        subHead: "Nearshore Software",
        subContent:
          "Streamline software development with our cost-effective nearshore services.",
        subHeadImg: "nearshore-software.webp",
        subCardLink: "/custom-software-development-company",
      },
      {
        subHead: "Custom Software",
        subContent:
          "Get advanced software that perfectly fits your business requirements.",
        subHeadImg: "custom-software.webp",
        subCardLink: "/custom-software-development-company",
      },
      {
        subHead: "CRM Development",
        subContent: "Enhance customer relationships with custom CRM software.",
        subHeadImg: "crm.webp",
        subCardLink: "/custom-software-development-company",
      },
      {
        subHead: "Agile Software",
        subContent:
          "Build flexible, agile software solutions that evolve with your business needs.",
        subHeadImg: "agile-software.webp",
        subCardLink: "/custom-software-development-company",
      },
      {
        subHead: "Offshore Development",
        subContent:
          "Outsource your development needs to our experienced offshore teams.",
        subHeadImg: "offshore-development.webp",
        subCardLink: "/custom-software-development-company",
      },
      {
        subHead: "ERP Software",
        subContent:
          "Manage and automate your business operations with powerful ERP software.",
        subHeadImg: "erp-software.webp",
        subCardLink: "/custom-software-development-company",
      },
    ],
  },
  {
    id: 4,
    serviceName: "service 04",
    cardTitle: "Mobile & Web Development",
    cardImg:
      "https://res.cloudinary.com/dvym3pvnu/image/upload/v1776779528/landExploreDataImg4_zjbrw6.webp",
    cardContent:
      "Create high performance mobile and web applications to engage users and expand your digital presence. Deliver seamless experiences across all devices.",
    cardBtn: "Explore",
    cardLink: "/contact-us",
    cardSubContents: [
      {
        subHead: "IOS App Development",
        subContent:
          "Build high-performance iOS apps for an exceptional user experience.",
        subHeadImg: "ios-app.webp",
        subCardLink: "/mobile-app-development-company",
      },
      {
        subHead: "Progressive App",
        subContent:
          "Develop fast, reliable, and engaging progressive web apps.",
        subHeadImg: "progressive-app.webp",
        subCardLink: "/mobile-app-development-company",
      },
      {
        subHead: "Android App Development",
        subContent: "Create feature-rich android apps for a global audience.",
        subHeadImg: "android-app.webp",
        subCardLink: "/mobile-app-development-company",
      },
      {
        subHead: "Web App Development",
        subContent: "Build responsive, secure, and scalable web applications.",
        subHeadImg: "web-app.webp",
        subCardLink: "/contact-us",
      },
    ],
  },
  {
    id: 5,
    serviceName: "service 05",
    cardTitle: "Digital Marketing",
    cardImg:
      "https://res.cloudinary.com/dvym3pvnu/image/upload/v1776779515/landExploreDataImg5_obfvr1.webp",
    cardContent:
      "Boost your brand visibility and reach your target audience with expert digital marketing strategies. Achieve progress with SEO, social media and content marketing.",
    cardBtn: "Explore",
    cardLink: "/contact-us",
    cardSubContents: [
      {
        subHead: "Branding",
        subContent:
          "Strengthen your brand identity with innovative marketing strategies.",
        subHeadImg: "branding.webp",
        subCardLink: "/contact-us",
      },
      {
        subHead: "Content Marketing",
        subContent:
          "Drive engagement and traffic with strategic content marketing.",
        subHeadImg: "content-marketing.webp",
        subCardLink: "/contact-us",
      },
      {
        subHead: "SEO & SMM",
        subContent:
          "Boost your online visibility with expert SEO and social media marketing.",
        subHeadImg: "seo.webp",
        subCardLink: "/contact-us",
      },
      {
        subHead: "ICO Marketing",
        subContent:
          "Launch your crypto project successfully with targeted ICO marketing.",
        subHeadImg: "ico.webp",
        subCardLink: "/contact-us",
      },
    ],
  },
  {
    id: 6,
    serviceName: "service 06",
    cardTitle: "FOREX Trading",
    cardImg:
      "https://res.cloudinary.com/dvym3pvnu/image/upload/v1776779517/landExploreDataImg6_wasd8p.webp",
    cardContent:
      "Build advanced FOREX trading platforms and tools to empower traders with automated solutions. Stay ahead in the market with reliable trading software.",
    cardBtn: "Explore",
    cardLink: "/contact-us",
    cardSubContents: [
      {
        subHead: "Custom Trading Platform",
        subContent:
          "Build a custom trading platform that meets your unique FOREX trading needs.",
        subHeadImg: "custom-trading.webp",
        subCardLink: "/forex-trading-software-development",
      },
      {
        subHead: `MT4 & MT5 Trading Software`,
        subContent:
          "Develop robust MT4 & MT5 trading platforms for enhanced performance.",
        subHeadImg: "mt.webp",
        subCardLink: "/forex-trading-software-development",
      },
      {
        subHead: "Forex Algorithm Trading Bot",
        subContent:
          "Optimize trades with smart, automated algorithmic trading bots.",
        subHeadImg: "forex-algorithm.webp",
        subCardLink: "/forex-trading-bot",
      },
      {
        subHead: "Forex Trading App Development",
        subContent:
          "Design and launch an advanced FOREX trading app for traders on the go.",
        subHeadImg: "forex-trading-app.webp",
        subCardLink: "/forex-trading-software-development",
      },
    ],
  },
];

export const industryCardData = [
  {
    id: 1,
    industryCardTitle: "Game Industry",
    industryCardContent:
      "Build immersive gaming experiences using blockchain technology.",
    industryCardImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746625536/game_owozsc.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 2,
    industryCardTitle: "Entertainment Industry",
    industryCardContent:
      "Explore new ways to engage audiences with blockchain in entertainment.",
    industryCardImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746625535/entertainment_e08xx1.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 3,
    industryCardTitle: "Event Industry",
    industryCardContent:
      "Manage events more efficiently with blockchain-powered ticketing and management.",
    industryCardImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746625536/event_vjhzvi.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 4,
    industryCardTitle: "On Demand Industry",
    industryCardContent:
      "Streamline operations for on-demand services using blockchain solutions.",
    industryCardImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746678073/on-demand_ueevxr.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 5,
    industryCardTitle: "Finance Industry",
    industryCardContent:
      "Drive growth with blockchain solutions developed for financial institutions.",
    industryCardImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746625535/finance_cubqd4.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 6,
    industryCardTitle: "Banking Industry",
    industryCardContent:
      "Innovate in the banking sector with secure and scalable blockchain technology.",
    industryCardImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746625534/banking_wdj6sd.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 7,
    industryCardTitle: "Insurance Industry",
    industryCardContent:
      "Automate and secure insurance processes with blockchain driven solutions.",
    industryCardImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746625537/insurance_hh0pz2.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 8,
    industryCardTitle: "Legal Industry",
    industryCardContent:
      "Simplify legal processes and enhance trust with blockchain for the legal industry.",
    industryCardImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746625541/legal_n4bhca.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 9,
    industryCardTitle: "Education Industry",
    industryCardContent:
      "Change learning with blockchain solutions for education.",
    industryCardImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746625535/education_igqcu2.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 10,
    industryCardTitle: "Health Industry",
    industryCardContent:
      "Improve healthcare services with secure and transparent blockchain applications.",
    industryCardImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746625536/health_hfdwkh.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 11,
    industryCardTitle: "Retail & E-Commerce",
    industryCardContent:
      "Enhance trust and efficiency in retail with blockchain for supply chain.",
    industryCardImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746625542/retail_udqsxy.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 12,
    industryCardTitle: "Restaurant",
    industryCardContent:
      "Boost operational efficiency and customer engagement with blockchain for restaurants.",
    industryCardImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746625542/restaurant_pnrmpm.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 13,
    industryCardTitle: "Travel Industry",
    industryCardContent:
      "Simplify travel services with secure and decentralized blockchain platforms.",
    industryCardImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746625542/travel_lawtgi.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 14,
    industryCardTitle: "Logistics Industry",
    industryCardContent:
      "Optimize supply chain and logistics operations with blockchain technology.",
    industryCardImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746625541/logistics_zbtzms.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 15,
    industryCardTitle: "Energy Industry",
    industryCardContent:
      "Improve transparency and sustainability with blockchain in the energy sector.",
    industryCardImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746625535/energy_gv6rjp.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 16,
    industryCardTitle: "Agriculture",
    industryCardContent:
      "Modernize farming practices with blockchain solutions for agriculture.",
    industryCardImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746625535/agri_s65bej.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 17,
    industryCardTitle: "Real Estates",
    industryCardContent:
      "Simplify property transactions with blockchain for real estate.",
    industryCardImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746625541/real-estate_ni4eyc.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 18,
    industryCardTitle: "Construction",
    industryCardContent:
      "Improvise project management with blockchain for construction with transparent solutions.",
    industryCardImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746625534/construction_blvuce.webp",
    industryCardLink: "/contact-us",
  },
];

export const blockchainImgData = [
  {
    id: 1,
    blockchainImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746688045/bitcoin_sa5dtr.webp",
    blockchainName: "Bitcoin",
  },
  {
    id: 2,
    blockchainImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746688045/eth_myjdd2.webp",
    blockchainName: "Ethereum",
  },
  {
    id: 3,
    blockchainImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746688045/solana_tjqly3.webp",
    blockchainName: "Solana",
  },
  {
    id: 4,
    blockchainImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746688044/binance_yf392v.webp",
    blockchainName: "Binance",
  },
  {
    id: 5,
    blockchainImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746688044/polygon_f0owey.webp",
    blockchainName: "Polygon",
  },
  {
    id: 6,
    blockchainImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746688044/ripple_ihww5n.webp",
    blockchainName: "Ripple",
  },
  {
    id: 7,
    blockchainImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746688045/tron_tdjl8i.webp",
    blockchainName: "Tron",
  },
  {
    id: 8,
    blockchainImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746688045/cardano_mioufu.webp",
    blockchainName: "Cardano",
  },
  {
    id: 9,
    blockchainImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746688044/avalanche_igaryb.webp",
    blockchainName: "Avalanche",
  },
  {
    id: 10,
    blockchainImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746688045/polkadot_ticp7q.webp",
    blockchainName: "Polkadot",
  },
  {
    id: 11,
    blockchainImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746688238/near_exsoil.webp",
    blockchainName: "Near",
  },
  {
    id: 12,
    blockchainImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746688044/aptos_dial6w.webp",
    blockchainName: "Aptos",
  },
  {
    id: 13,
    blockchainImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746688045/stellar_wsznvn.webp",
    blockchainName: "Stellar",
  },
  {
    id: 14,
    blockchainImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746688044/arbitrum_egqg80.webp",
    blockchainName: "Arbitrum",
  },
  {
    id: 15,
    blockchainImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746688045/cosmos_wazepo.webp",
    blockchainName: "Cosmos",
  },
];

export const frontendImages = [
  { techImg: "html.webp", alt: "HTML" },
  { techImg: "vue.webp", alt: "Vue" },
  { techImg: "nuxt.webp", alt: "Nuxt" },
  { techImg: "css.webp", alt: "CSS" },
  { techImg: "svelte.webp", alt: "Svelte" },
  { techImg: "next.webp", alt: "Next" },
  { techImg: "react.webp", alt: "React" },
  { techImg: "angular.webp", alt: "Angular" },
];

export const featureCardData = [
  {
    id: 1,
    cardTitle: "User-Friendly interface",
    cardContent:
      " The success of any ride-hailing service lies in its simplicity. An Uber clone app offers an intuitive, easy-to-navigate interface that enables users to book rides with just a few taps. The seamless design ensures a smooth user experience, from signup to ride completion.",
    icon: "user-friendly.webp",
  },
  {
    id: 2,
    cardTitle: "Real-Time tracking",
    cardContent:
      "One of the standout features of an Uber clone is real-time GPS tracking. Both drivers and passengers can view each other’s locations, making ride coordination simple and efficient. This also ensures security and transparency.",
    icon: "real-time.webp",
  },
  {
    id: 3,
    cardTitle: "Multiple payment options",
    cardContent:
      " An Uber clone app integrates various payment gateways, allowing users to pay using credit cards, debit cards, digital wallets, or even cash. The secure payment process ensures that users feel safe when using your app.",
    icon: "multiple.webp",
  },
  {
    id: 4,
    cardTitle: "Driver and passenger profiles",
    cardContent:
      "The Uber clone provides separate dashboards for drivers and passengers. Users can set up profiles, manage personal information, and review their ride history. Drivers can also track their earnings.",
    icon: "driver.webp",
  },
  {
    id: 5,
    cardTitle: "In-App communication",
    cardContent:
      "Efficient communication between drivers and passengers is critical. The Uber clone app includes in-app messaging and calling features that make it easier for both parties to stay connected before and during the ride.",
    icon: "communication.webp",
  },
  {
    id: 6,
    cardTitle: "Ride scheduling",
    cardContent:
      "Your Uber clone can include a ride-scheduling feature that allows users to book rides in advance. This is particularly useful for airport transfers or early morning commutes.",
    icon: "ride.webp",
  },
  {
    id: 7,
    cardTitle: "Fare estimation",
    cardContent:
      "With a built-in fare estimation feature, the Uber clone app provides users with the estimated cost of their trip before they book. This enhances transparency and helps passengers make informed decisions.",
    icon: "fare.webp",
  },
  {
    id: 8,
    cardTitle: "Ratings and reviews",
    cardContent:
      " Your Uber clone can include a ride-scheduling feature that allows users to book rides in advance. This is particularly useful for airport transfers or early morning commutes.",
    icon: "ratings.webp",
  },
];

export const jobOpeningsData = [
  {
    id: 1,
    department: "Designing",
    role: "UI/UX Designer",
    durationTitle: "Duration",
    duration: "3+ months | Paid",
    type: "Internship",
    time: "11:30 am - 5:00 pm",
    months: "4 months ago",
  },
  {
    id: 2,
    department: "Development",
    role: "Full Stack Developer",
    durationTitle: "Duration",
    duration: "3+ months | Paid",
    type: "Internship",
    time: "11:30 am - 5:00 pm",
    months: "4 months ago",
  },
  {
    id: 3,
    department: "Development",
    role: "Smart contract developer",
    durationTitle: "Experience",
    duration: "6+ months | Paid",
    type: "Full Time",
    time: "9:30 am - 7:00 pm",
    months: "6 months ago",
  },
  {
    id: 4,
    department: "Designing",
    role: "UI/UX Designer",
    durationTitle: "Duration",
    duration: "3+ months | Paid",
    type: "Internship",
    time: "11:30 am - 5:00 pm",
    months: "4 months ago",
  },
  {
    id: 5,
    department: "Development",
    role: "Full Stack Developer",
    durationTitle: "Experience",
    duration: "3+ months | Paid",
    type: "Internship",
    time: "11:30 am - 5:00 pm",
    months: "4 months ago",
  },
  {
    id: 6,
    department: "Designing",
    role: "UI/UX Designer",
    durationTitle: "Duration",
    duration: "3+ months | Paid",
    type: "Internship",
    time: "11:30 am - 5:00 pm",
    months: "4 months ago",
  },
];

export const internshipOpeningsData = [
  {
    id: 1,
    department: "Internship",
    role: "Full-Stack Web Development",
    durationTitle: "Duration",
    duration: "3+ months | Paid",
    type: "Internship",
    time: "11:30 am - 5:00 pm",
    months: "4 months ago",
  },
  {
    id: 2,
    department: "Internship",
    role: "MERN Stack",
    durationTitle: "Duration",
    duration: "3+ months | Paid",
    type: "Internship",
    time: "11:30 am - 5:00 pm",
    months: "4 months ago",
  },
  {
    id: 3,
    department: "Internship",
    role: "MEAN Stack",
    durationTitle: "Experience",
    duration: "6+ months | Paid",
    type: "Full Time",
    time: "9:30 am - 7:00 pm",
    months: "6 months ago",
  },
  {
    id: 4,
    department: "Internship",
    role: "AI & Machine Learning",
    durationTitle: "Duration",
    duration: "3+ months | Paid",
    type: "Internship",
    time: "11:30 am - 5:00 pm",
    months: "4 months ago",
  },
  {
    id: 5,
    department: "Internship",
    role: "Cloud Computing",
    durationTitle: "Experience",
    duration: "3+ months | Paid",
    type: "Internship",
    time: "11:30 am - 5:00 pm",
    months: "4 months ago",
  },
  {
    id: 6,
    department: "Internship",
    role: "Data Science & Analytics",
    durationTitle: "Duration",
    duration: "3+ months | Paid",
    type: "Internship",
    time: "11:30 am - 5:00 pm",
    months: "4 months ago",
  },
  {
    id: 7,
    department: "Internship",
    role: "Cybersecurity",
    durationTitle: "Duration",
    duration: "3+ months | Paid",
    type: "Internship",
    time: "11:30 am - 5:00 pm",
    months: "4 months ago",
  },
  {
    id: 8,
    department: "Internship",
    role: "Blockchain Technology",
    durationTitle: "Duration",
    duration: "3+ months | Paid",
    type: "Internship",
    time: "11:30 am - 5:00 pm",
    months: "4 months ago",
  },
  {
    id: 9,
    department: "Internship",
    role: "Software Testing",
    durationTitle: "Duration",
    duration: "3+ months | Paid",
    type: "Internship",
    time: "11:30 am - 5:00 pm",
    months: "4 months ago",
  },
  {
    id: 10,
    department: "Internship",
    role: "Digital Marketing",
    durationTitle: "Duration",
    duration: "3+ months | Paid",
    type: "Internship",
    time: "11:30 am - 5:00 pm",
    months: "4 months ago",
  },
  {
    id: 11,
    department: "Internship",
    role: "Business Development & Sales",
    durationTitle: "Duration",
    duration: "3+ months | Paid",
    type: "Internship",
    time: "11:30 am - 5:00 pm",
    months: "4 months ago",
  },
  {
    id: 12,
    department: "Internship",
    role: "Human Resources (HR)",
    durationTitle: "Duration",
    duration: "3+ months | Paid",
    type: "Internship",
    time: "11:30 am - 5:00 pm",
    months: "4 months ago",
  },
];
